import React, { useMemo } from 'react'
import WarningDialog from 'components/libs/dialog/warningDialog/WarningDialog'
import { DialogActions } from 'components/pages/domains/editDomain/editDomainWarningDialogs/EditDomainWarningDialog'
import { useFormatMessage } from 'lib/localization'

const BASE_I18N_KEY = 'ess.domains'
const DIALOG_I18N_KEY = 'ess.dialog'

export const DisableSpoolingWarningDialog = ({ onConfirm, onClose }: DialogActions) => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatDialogMessage = useFormatMessage(DIALOG_I18N_KEY)

  return useMemo(
    () => (
      <WarningDialog
        title={formatMessage('edit_domain.warnings.disable_spooling.title')}
        description={formatMessage('edit_domain.warnings.disable_spooling.description')}
        onCancel={onClose}
        onConfirm={onConfirm}
        confirmButtonLabel={formatDialogMessage('ok')}
      />
    ),
    [formatMessage, onClose, onConfirm, formatDialogMessage]
  )
}
